import { BenefitConfiguration } from "./benefit-configuration";
import { BenefitType } from "./benefit-type";

export class OfferBenefit {

    id: number = 0;

    currentBenefitConfiguration: BenefitConfiguration | null | undefined = new BenefitConfiguration();
    currentValue!: string;

    offeredBenefitConfiguration: BenefitConfiguration | null | undefined = new BenefitConfiguration();
    offerredValue!: string;

    currentValueOut!: string;
    currentDescriptionOut!: string;

    benefitOut!: string;
    benefitTypeOut: BenefitType = new BenefitType();
}
